import React, { useEffect } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import { scrollToElement } from 'Components/utils/scroll/scrollToElement';
import { Icon } from 'Components/frameworks/icon/Icon';
const BEACON_SELECTOR = 'FormFeedbackBeacon';
type Props = {
  className?: string;
  hasAutoScroll?: boolean;
  isError?: boolean;
  message: string | null | undefined;
};
export const FormFeedback = ({ className, hasAutoScroll, isError, message }: Props) => {
  useEffect(() => {
    if (hasAutoScroll) {
      scrollToElement(`[data-testid="${BEACON_SELECTOR}"]`);
    }
  }, []);
  return (
    <p
      className={classnames(
        'my-10 flex items-center gap-10 text-14 font-bold leading-1',
        `${isError ? 'text-red' : 'text-success'}`,
        className,
      )}
      data-testid={BEACON_SELECTOR}
    >
      <Icon
        className={classnames('shrink-0', {
          'px-5 pt-5': !isError,
        })}
        name={isError ? ICONS.WARNING : ICONS.CHECK}
        width="1.25rem"
      />
      <span data-testid="FormFeedback-message">{message}</span>
    </p>
  );
};
